module.exports = __webpack_public_path__ + "img/whatsapp.1d7aff97.svg";